import { Link } from '@chakra-ui/next-js';
import { LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { MouseEvent } from 'react';

import { Replace } from '$utils/replace';

interface ActiveLinkProps extends Replace<ChakraLinkProps, { href: string }> {
  shouldMatchExactHref?: boolean;
}

export function ActiveLink({
  children,
  shouldMatchExactHref,
  onClick,
  fontSize = '14px',
  fontWeight = 500,
  ...props
}: ActiveLinkProps) {
  const { asPath } = useRouter();
  const href = props.href;

  let isActive = false;
  if ((asPath === '' || asPath === '/') && (href === '' || href === '/')) {
    isActive = true;
  } else if (shouldMatchExactHref && asPath === href) {
    isActive = true;
  } else if (!shouldMatchExactHref && href !== '/' && asPath.startsWith(href)) {
    isActive = true;
  }

  return (
    <Link
      {...props}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event);
      }}
      fontFamily="body"
      fontSize={fontSize}
      fontWeight={fontWeight}
      letterSpacing="-0.005em"
      color={isActive ? 'text.primary' : 'text.muted'}
      opacity={isActive ? 1 : 0.85}
      pos="relative"
      pb="2px"
      borderBottom="1px solid"
      borderColor={isActive ? 'accent.500' : 'transparent'}
      transition="color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease"
      _hover={{
        color: 'text.primary',
        textDecoration: 'none',
        opacity: 1,
      }}
    >
      {children}
    </Link>
  );
}
